import { CustAcctAuthorizations } from "./CustAcctAuthorizations";

class BaseEAuthModel {
    isTransactionFromSLOA: boolean;
    eauthSelected: boolean;
    isTransactionFromSLOAOrSLOA: boolean;
    numberOfAuthRequired: number;
    eauthEligibilityServiceSLOAError: boolean;
    eauthEligibilityServiceDown: boolean;
    eauthEligibilityServiceSLOAErrorMsg: string;
    isOrgAccount: boolean;
    accountRestricted: boolean;
    orgOrEduSavingsAccount: boolean;
    custAcctAuthorizationsListEmpty: boolean;
    eauthInd: boolean;
    eauthSLOAInd: boolean;
    allAccountHolderIneligible: boolean;
    numOfIneligibleCust: number;
    eauthEligibilityServiceDownErrorMsg: string;
    custAcctAuthorizationsList: CustAcctAuthorizations;
    transactionType: string;
    submitButtonsDisable: string;
    txnType: string;
}

export class EAuthModel extends BaseEAuthModel {
    custAcctSLOAAuthorizationsList: CustAcctAuthorizations;
}

export class ChecksApiEAuthModel extends BaseEAuthModel {
    custAcctAuthorizationsSLOAList: CustAcctAuthorizations;
}